import { useNavigate } from 'react-router-dom';

import { InfoContent } from './components';

import { NavBar } from '@/components';
import ROUTES from '@/router/routes';

export const InfoML = () => {
  const navigate = useNavigate();

  return (
    <NavBar
      mobile={{
        leftContent: {
          backAction: () => {
            navigate(ROUTES.minileagues.home);
          },
        },
        centerContent: {
          title: 'Miniligas',
        },
      }}
    >
      <div className="px-6 pt-4 ">
        <InfoContent />
      </div>
    </NavBar>
  );
};
